const MAX_PACKAGE_ADULTS_COUNT = 4;
const MAX_PACKAGE_KIDS_COUNT = 3;

export const checkTouristsCount = (
  searchType: string,
  tourists?: { adults?: number; kids?: number[] },
  showHeaderPopup = true,
) => {
  if (
    showHeaderPopup &&
    searchType === 'package' &&
    ((tourists?.adults && tourists.adults > MAX_PACKAGE_ADULTS_COUNT) ||
      (tourists?.kids && tourists.kids.length > MAX_PACKAGE_KIDS_COUNT))
  )
    return { adults: 2, kids: [], limitPopupShown: true };

  return {
    adults: tourists?.adults ?? 2,
    kids: tourists?.kids ?? [],
    limitPopupShown: false,
  };
};

export const checkTouristsCountForMainPage = (searchType: string) => {
  const adultsInitialValue = sessionStorage.getItem('adultsValue');
  const kidsInitialValue = sessionStorage.getItem('kidsValue');

  const hasTooManyAdults =
    adultsInitialValue && Number(adultsInitialValue) > MAX_PACKAGE_ADULTS_COUNT;
  const hasTooManyChildren =
    kidsInitialValue &&
    JSON.parse(kidsInitialValue).length > MAX_PACKAGE_KIDS_COUNT;

  let result = { adults: 2, kids: [], limitPopupShown: false };

  if (searchType === 'package' && (hasTooManyAdults || hasTooManyChildren)) {
    sessionStorage.setItem('adultsValue', '2');
    sessionStorage.setItem('kidsValue', '[]');
    return { adults: 2, kids: [], limitPopupShown: true };
  }
  if (adultsInitialValue)
    result = { ...result, adults: Number(adultsInitialValue) };
  if (kidsInitialValue)
    result = { ...result, kids: JSON.parse(kidsInitialValue) };
  return result;
};
